import { mappedArray } from '@10000/common'
import { Box } from '.'

export const Progress = ({ step = 1, max = 1 }) => (
  <Box fullWidth gap={8} className="progress progress-bar">
    {mappedArray(max, i => <Box
      key={i}
      grow={step === i + 1 ? 2 : 1}
      height={4}
      r={2}
      background={step === i + 1 ? 'var(--blue)' : 'white'}
      transition="0.5s"
    />)}
  </Box>
)